import React from "react";
import { QrFormSection } from "routes/qrcodes/qr_design/QrFormSection";
import { QR_DESIGN_DETAILS } from "forms/list";
import { getFormValues } from "redux-form";
import { ColorInput } from "routes/qrcodes/qr_design/CustomInputs/ColorInput";
import { inRange, required } from "forms/validators/validators";
import { ReduxControls } from "rhombus-react";
import { useSelector } from "react-redux";
import { normalizeOptionToString } from "social/utils";

import "./DotSettingsSection.css";


export const COLOR_TYPES = {
	SOLID: "solid",
	GRADIENT: "gradient",
};
export const gradientColorTypes = [
	{
		value: "linear",
		label: "Linear",
	},
	{
		value: "radial",
		label: "Radial",
	}
];
export const qrCodeDotsTypeOptions = [
	{ value: 'square', label: 'Square' },
	{ value: 'dots', label: 'Dots' },
	{ value: 'random-dots', label: 'Random dots' },
	{ value: 'vertical-lines', label: 'Vertical lines' },
	{ value: 'horizontal-lines', label: 'Horizontal lines' },
	{ value: 'diamond', label: 'Diamonds' },
	{ value: 'triangle', label: 'Triangle' },
	{ value: 'rounded', label: 'Rounded' },
	{ value: 'extra-rounded', label: 'Extra rounded' },
	{ value: 'classy', label: 'Classy' },
	{ value: 'classy-rounded', label: 'Classy rounded' },
];

const solidColorTypeFormData = [
	{
		key: "solidColorRow",
		name: `${COLOR_TYPES.SOLID}.color`,
		type: "color",
		label: "Dots Color",
		component: ColorInput,
		validate: [required],
		required: true,
		className: "xs-input",
	},
];
const gradientColorTypeFormData = [
	{
		key: "gradientColorTypeRow",
		name: `${COLOR_TYPES.GRADIENT}.type`,
		type: "select",
		label: "Gradient Type",
		placeholder: "Select a gradient type...",
		component: ReduxControls.Select,
		isClearable: false,
		onMenuScrollToBottom: () => {},
		validate: [required],
		required: true,
		options: gradientColorTypes,
		normalize: normalizeOptionToString,
		format: value => (gradientColorTypes.find(option => option.value === value)),
		className: "sm-input",
	},
	{
		key: "gradientRotationRow",
		name: `${COLOR_TYPES.GRADIENT}.rotation`,
		type: "number",
		label: "Gradient Rotation",
		component: ReduxControls.Input,
		validate: [required, inRange({ min: 0, max: 360 })],
		min: 0,
		max: 360,
		required: true,
		step: 1,
		format: value => value?.toString(),
		normalize: (value => parseFloat(value)),
		className: "sm-input",
	},
	{
		key: "gradientColorsRow",
		name: `${COLOR_TYPES.GRADIENT}.colorStops[0]`,
		type: "color",
		label: "Color 1",
		component: ColorInput,
		validate: [required],
		required: true,
		format: value => value?.color,
		normalize: (value) => {return { offset: 0, color: value };},
		className: "xs-input",
	},
	{
		key: "gradientColorsRow",
		name: `${COLOR_TYPES.GRADIENT}.colorStops[1]`,
		type: "color",
		label: "Color 2",
		component: ColorInput,
		validate: [required],
		required: true,
		format: value => value?.color,
		normalize: (value) => {return { offset: 1, color: value };},
		className: "xs-input",
	},
];

export let DotSettingsSection = (props) => {
	const reduxFormData = useSelector(getFormValues(QR_DESIGN_DETAILS));
	const isSolidColorType = reduxFormData?.dotsColorType === COLOR_TYPES.SOLID;

	const formData = [
		{
			key: "dotStyleRow",
			name: "details.dotsOptions.type",
			type: "select",
			label: "Dot Style",
			placeholder: "Select a dot style...",
			component: ReduxControls.Select,
			isClearable: false,
			onMenuScrollToBottom: () => {},
			validate: [required],
			required: true,
			options: qrCodeDotsTypeOptions,
			normalize: normalizeOptionToString,
			className: "sm-input",
			format: value => (qrCodeDotsTypeOptions.find(option => option.value === value)),
			menuPlacement: "top",
		},
		{
			key: "dotsColorTypeRow",
			name: "dotsColorType",
			type: "radio",
			label: "Dots Color Type",
			className: "xl-input",
			component: ReduxControls.CheckboxList,
			items: [
				{
					label: "Solid",
					value: COLOR_TYPES.SOLID,
					name: "dotsColorType",
				},
				{
					label: "Gradient",
					value: COLOR_TYPES.GRADIENT,
					name: "dotsColorType",
				}
			],
			isSearchable: false,
			normalize: (value) => {return value[0];},
			props:{
				isRedux:       true,
				name:          "dotsColorType",
				isGridLayout:  true,
				showSelectAll: false,
				value: [reduxFormData?.dotsColorType],
			},
		},
	];

	return (
		<QrFormSection
			formFields={[
				...formData,
				...(isSolidColorType ? solidColorTypeFormData : gradientColorTypeFormData),
			]}
			formTitle={"Dot Settings"}
			readOnly={props.readonly}
		/>
	);
};

DotSettingsSection.displayName = "DotSettingsSection";
